import { useMemo, useState } from 'react';

interface Handlers {
    increment: () => void;
    decrement: () => void;
    reset: () => void;
}

export const useCount = (
    initialValue = 0,
    { min = 0, max = 10, step = 1 } = {}
): [number, Handlers] => {
    const [state, setState] = useState<number>(initialValue);

    const handlers = useMemo<Handlers>(
        () => ({
            increment: () => {
                setState(current =>
                    current >= max ? current : current + step
                );
            },
            decrement: () => {
                setState(current =>
                    current <= min ? current : current - step
                );
            },
            reset: () => {
                setState(initialValue);
            },
        }),
        [initialValue, max, min, step]
    );

    return [state, handlers];
};
